module.exports = __webpack_public_path__ + "static/media/partitions_lcs_60y_n.a659d30e.csv";